import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Award, Users, CheckCircle, ArrowRight } from 'lucide-react';
import { aboutContent, ownerInfo, companyInfo } from '../data/mock';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="page-about">
      <SEO 
        title="À propos de PaysFor | Élagueur professionnel à Québec"
        description="Découvrez PaysFor, entreprise spécialisée en abattage d'arbres et élagage à Québec. Équipe qualifiée, sécurité prioritaire, service personnalisé dans la Capitale-Nationale."
        keywords="entreprise élagage Québec, arboriste professionnel Québec, équipe abattage arbres Capitale-Nationale"
        canonical="/a-propos"
      />
      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <h1 className="display-medium">À propos de PaysFor</h1>
          <p className="body-large">
            Passion, expertise et professionnalisme au service de vos arbres
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="about-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2 className="heading-1">Qui sommes-nous?</h2>
              <p className="body-large">{aboutContent.introduction}</p>
              <div style={{ marginTop: 'var(--spacing-medium)' }}>
                <p className="body-medium"><strong>Zone principale:</strong> {companyInfo.serviceArea}</p>
                <p className="caption" style={{ fontStyle: 'italic', marginTop: 'var(--spacing-xs)' }}>
                  {companyInfo.serviceAreaNote}
                </p>
              </div>
            </div>
            <div className="intro-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/rt7jsnob_42f10c2d-52b7-4833-a9a9-e144883cb78d.jpg"
                alt="Travail professionnel Paysfor"
                className="rounded-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="about-mission">
        <div className="container">
          <div className="mission-card">
            <h2 className="heading-1">Notre mission</h2>
            <p className="body-large">{aboutContent.mission}</p>
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="about-expertise">
        <div className="container">
          <h2 className="heading-1 section-title">Notre expertise</h2>
          <div className="expertise-grid">
            {aboutContent.expertise.map((item, index) => (
              <div key={index} className="expertise-item">
                <CheckCircle size={24} className="expertise-icon" />
                <p className="body-medium">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety & Professionalism */}
      <section className="about-safety">
        <div className="container">
          <div className="safety-content">
            <div className="safety-icon-large">
              <Shield size={80} />
            </div>
            <div className="safety-text">
              <h2 className="heading-1">{aboutContent.safety.title}</h2>
              <ul className="safety-list">
                {aboutContent.safety.points.map((point, index) => (
                  <li key={index} className="body-medium">
                    <CheckCircle size={20} />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Owner Section */}
      <section className="about-owner">
        <div className="container">
          <div className="owner-content">
            <div className="owner-image-wrapper">
              <img 
                src={ownerInfo.photo}
                alt={ownerInfo.name}
                className="owner-image"
              />
            </div>
            <div className="owner-text">
              <h2 className="heading-1">Rencontrez {ownerInfo.name}</h2>
              <p className="body-large owner-bio">{ownerInfo.bio}</p>
              <div className="owner-qualifications">
                <div className="qualification-badge">
                  <Award size={24} />
                  <span>Formations spécialisées</span>
                </div>
                <div className="qualification-badge">
                  <Shield size={24} />
                  <span>Certifications reconnues</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="about-why-choose">
        <div className="container">
          <h2 className="heading-1 section-title">Pourquoi choisir Paysfor?</h2>
          <div className="why-choose-grid">
            {aboutContent.whyChoose.map((reason, index) => (
              <div key={index} className="why-choose-item">
                <div className="why-choose-number">{index + 1}</div>
                <p className="body-medium">{reason}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">Travaillons ensemble</h2>
            <p className="body-large">
              Confiez-nous vos projets arboricoles, paysagers et forestiers. Obtenez une soumission gratuite dès aujourd'hui.
            </p>
            <Link to="/contact" className="btn-cta">
              Demander une soumission gratuite
              <ArrowRight size={20} style={{ marginLeft: '8px' }} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
